import React, { Component } from 'react';
import { Example, Properties, SourceCode } from 'examples';
import VolumeSlider from './VolumeSlider';

export default class SliderExample extends Component {

  state = {
    volume: 0.8
  };

  onChange = e => this.setState(e.target.value);

  onVolumeSliderChange = e => this.setState({
    volume: e.target.value
  });

  render() {
    return (
      <Example {...this.props}>
        <Properties
          defaultProps={VolumeSlider.defaultProps}
          propTypes={VolumeSlider.propTypes}
          propValues={this.state}
          onChange={this.onChange}
        />
        <VolumeSlider
          animate={false}
          onChange={this.onVolumeSliderChange}
          {...this.state}
        />
        <SourceCode querySelector=".core-volume-slider" />
      </Example>
    );
  }

}
